import { useEffect } from 'react'
import { useAnalyticsTrackEvent } from 'hooks/useAnalyticsTrackEvent'

const UPSCOPE_OPTIONS = {
  allowRemoteClick: false,
  allowRemoteScroll: true,
  allowRemoteType: false,
  showUpscopeLink: false,
}

const Upscope = ({ upscopeUrl }) => {
  const { analyticsTrackEvent } = useAnalyticsTrackEvent()

  useEffect(() => {
    if (!upscopeUrl || typeof window === 'undefined' || window.Upscope) return

    const trackUpscopeEvent = ({ action, category, event_name, label }) => {
      analyticsTrackEvent({
        action,
        category,
        event_action: 'app_event',
        event_name,
        label,
        track_event: 'event',
      })
    }

    // Fires when Upscope is being initialized
    trackUpscopeEvent({
      action: 'Initialize Service',
      category: 'co_browse',
      event_name: 'Upscope - initializing Upscope',
      label: 'Upscope Initialize',
    })

    // Create the Upscope command queue
    const i = function () {
      i.c(arguments)
    }

    i.q = []
    i.c = (args) => {
      i.q.push(args)
    }

    window.Upscope = i

    // Initialize Upscope with options and the session-end tracking callback
    window.Upscope('init', {
      ...UPSCOPE_OPTIONS,
      onSessionEnd() {
        trackUpscopeEvent({
          action: 'end_session_click',
          category: 'co_browse',
          event_name: 'Upscope - Co-browse - Session End - Client Leave',
          label: 'Co-browse-end',
        })
      },
    })

    // Fires when an agent requests a co-browse session
    window.Upscope('on', 'sessionRequest', () => {
      trackUpscopeEvent({
        action: 'co_browse_pop_up',
        category: 'co_browse',
        event_name: 'Upscope - Co-browse - Session Requested - Agent',
        label: 'Co-browse-requested',
      })
    })

    // Fires when the client accepts the session or a session continues
    const onSessionStartOrContinue = () => {
      trackUpscopeEvent({
        action: 'yes_click',
        category: 'co_browse',
        event_name: 'Upscope - Co-browse - Session Start - Client Join',
        label: 'Co-browse-start',
      })
    }

    window.Upscope('on', 'sessionStart', 'sessionContinue', onSessionStartOrContinue)

    // Dynamically load the Upscope SDK
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = upscopeUrl
    document.head.appendChild(script)
  }, [analyticsTrackEvent, upscopeUrl])

  return null
}

export default Upscope
